import {
    CircularProgress,
    Container,
    Grid,
    IconButton,
    InputAdornment,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Theme,
} from "@material-ui/core";
import React, { useContext } from "react";
import Button from "@material-ui/core/Button";
import { UserContext } from "../../contexts/AppContext";
import SessionHandler from "../../https/SessionHandler";
import { useHistory } from "react-router-dom";
import { ProfilService } from "./services/ProfilService";
import {
    getErrorLabel,
    IUser,
    UserErrorMessage,
    UserErrorMessageFromServer,
} from "../../utils/UserInterfaces";
import { createStyles } from "@material-ui/styles";
import { Visibility, VisibilityOff, CheckBox, Warning } from "@material-ui/icons";
import {
    PasswordEditState,
    typeGender,
    typeLang,
} from "../components/Register/services/RegisterService";
import { AfriqSnackbar } from "../components/OverridingMaterial/AfriqSnackbar";
import { ISnackbar } from "../../utils/enum/snackBarType";
import { colors } from "../../styles/defaultColors";
import { useTranslation } from "react-i18next";
import { fileToBase64, TestPasswordStrength } from "../../utils/App";
import moment from "moment";
import { defaultUserValue } from "../../utils/defaultNullValues";
// import { ERoles } from "../../utils/enum";
// import { RegisterValidationOTP } from "../components/Register/components/RegisterValidationOTP";
import { GlobalValidationOTPDialog } from "../components/GlobalValidationOTPDialog";
import { CountryPhoneList } from "../../utils/CountryList";
import { ModalConfirm } from "./Components/ModalConfirm";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        profil: {
            background: "#F7F7F7", //03265 061 29
            paddingTop: 27,
            paddingBottom: 27,
        },
        avatarContainer: {
            height: "auto",
            borderRadius: 8,
            padding: "40px !important",
            background: "#ffffff",
            marginBottom: theme.spacing(2),
        },
        personalInfoContainer: {
            height: "auto",
            borderRadius: 8,
            padding: "30px !important",
            background: "#ffffff",
        },
        info: {
            background: "#ffffff",
        },

        inputAvatar: {
            display: "none",
        },
        avatar: {
            display: "flex",
            width: 150,
            height: 150,
            borderRadius: "50%",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
            backgroundSize: "cover",
            boxShadow: "0px 3px 5px -4px",
        },
        changeAvatarContainer: {
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        changeAvatarButton: {
            textTransform: "capitalize",
        },
        icon: {
            position: "relative",
            top: -4,
        },

        input: {
            "&::placeholder": {
                textOverflow: "ellipsis !important",
                color: "#000000",

                opacity: 10,
            },
        },
        updateInfosButtonsContainer: {
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            alignItems: "center",
        },
        button: {
            background: "#890608",
            color: "white",
            borderRadius: 100,
            fontFamily: 'Josefin Sans',
            fontSize: 14,
            textTransform: "none",
            padding: "8px 14px",
            marginLeft: 20,
            "&:hover": {
                background: "#B5551B"
            },
        },
        updateButton: {
            borderRadius: 100,
            textTransform: "none",
            fontSize: 14,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            textAlign: "center",
            fontFamily: 'Josefin Sans',
            background: "#AAAAAA",
            color: "#ffffff",
            padding: "8px 14px",
            "&:hover": {
                background: "#B5551B"
            },
        },
        label: {
            fontFamily: 'Josefin Sans',
            fontSize: 16,
            color: '#000000'
        },
        passwordStrength: {
            width: '100%',
            height: 3,
            background: '#878787',
            marginBottom: 10,
            marginTop: -7,
        },
        passwordCriteria: {
            paddingLeft: 0,
            paddingTop: 16,
            '& p': {
                margin: 0,
                fontSize: 13,
                marginBottom: 10
            }
        },
        "@global": {
            ".MuiInputBase-input": {
                fontFamily: 'Josefin Sans',
                fontSize: 14,
                color: '#000000'
            },
            ".MuiInputBase-input::placeholder": {
                opacity: 0.7
            }
        }
    })
);

const profilService = new ProfilService();
export function MyProfil(props: {
    embed?: boolean
}) {
    const { embed } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const history = useHistory();
    let errors: string[] = [];
    const [errorMessages, setErrorMessages] = React.useState<string>("");
    const [snackValues, setSnackValues] = React.useState<ISnackbar>({
        type: "success",
        open: false,
        message: "",
    });

    const inputfileRef = React.useRef<HTMLInputElement | null>(null);
    const [loadingPage, setLoadingPage] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [fileURL, setFileURL] = React.useState<string>("");
    const [oldUserInfos, setOldAllUserInfo] = React.useState<IUser | null>(
        null
    );
    const [openDialog, setOpenDialog] = React.useState(false);
    const [validationCodeEntered, setValidationCodeEntered] = React.useState<number | null>(null)
    const [validationCodeData, setValidationCodeData] = React.useState<{ userId: string, userEmail: string, smsValidationCode: number, userPhone: string, userCountry: string, codePhone: string }>({
        userId: '',
        userEmail: '',
        userPhone: '',
        userCountry: '',
        smsValidationCode: 0,
        codePhone : '',
    });
    const [loadingValidation, setLoadingValidation]= React.useState<boolean>(false)
    const [codePhone, setCodePhone] = React.useState("");

    const [colorPassword, setColorPassword] = React.useState<string>('#878787')

    const [countriesList, setCountiresList]=React.useState<any>([])

    const [allUserInfos, setAllUserInfos] = React.useState<IUser>(defaultUserValue);

    const [handlePassword, setHandlePassword] = React.useState<PasswordEditState>({
        password: "",
        showPassword: false,
        newPassword: "",
        showNewPassword: false,
        confirmPassword: "",
        showConfirmPassword: false,

    });

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])

    React.useEffect(() => {
        setCodePhone(CountryPhoneList.filter((devi: any) => devi.name?.toLowerCase() === allUserInfos.country?.toLowerCase())[0]?.dial_code)
    }, [allUserInfos.country])

    React.useEffect(() => {
        if (user.email) {
            setLoadingPage(true);
            profilService
                .getUserById(user._id)
                .then((response) => {
                    if (response.success) {
                        setAllUserInfos(response.data);
                        setOldAllUserInfo(response.data);
                    }
                    setLoadingPage(false)
                })
                .catch((error) => {
                    console.error("Profil component", error);
                    setLoadingPage(false)
                });
        } else {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                    }
                })
                .catch((err) => {
                    history.push("/");
                });
        }
    }, [user, history, isConnected, setUser]);
    
    React.useEffect(()=>{
        profilService.getAllDestination().then(response=>{
            if(response.success){
              setCountiresList(response.data)
            }
          });
    },[])

    const clickChangeAvatarInput = () => {
        inputfileRef.current?.click();
    };

    const handleCloseLoginDialog = () => {
        setOpenDialog(false);
      };
      
    const handlChangeAvatar = async (event: any) => {
        const file = event.target.files[0];
        setFileURL(URL.createObjectURL(file));
        setAllUserInfos({ ...allUserInfos, avatar: await fileToBase64(file) });

    };

    const triggerUpdatingForm = () => {
        setIsUpdating(!isUpdating);
    };

    const cancelUpdatingForm = () => {
        if (oldUserInfos) setAllUserInfos(oldUserInfos);
        setFileURL("");
        setIsUpdating(false);
    };

    const handleClickShowPassword = (key: string, val: boolean) => {
        setHandlePassword({
            ...handlePassword,
            [key]: !val,
        });
    };

    const handleChangeDate = (n: string, d: string) => {
        setAllUserInfos({
            ...allUserInfos,
            [n]: d,
        });
    };

    const onChangeHandler = (event: any): void => {
        setAllUserInfos({
            ...allUserInfos,
            [event.target.name]: event.target.value,
        });
        if (event.target.name === 'newPassword') {
            setColorPassword(TestPasswordStrength(event.target.value))
        }
    };

    const isFromValidate = (values: IUser): boolean => {
        if (values.firstName === "" || values.lastName === "") {
            if (!errors.includes("EMPTY NAME"))
                errors = [...errors, "EMPTY NAME"];
        } else if (values.email === "") {
            if (!errors.includes("EMPTY EMAIL"))
                errors = [...errors, "EMPTY EMAIL"];
        } else if (values.newPassword || values.confirmPassword) {
            if (values.newPassword !== values.confirmPassword) {
                if (!errors.includes("PASSWORD DIFFERENT"))
                    errors = [...errors, "PASSWORD DIFFERENT"];
            }
            if (colorPassword !== 'green') {
                if (!errors.includes("PASSWORD WEAK"))
                    errors = [...errors, "PASSWORD WEAK"]
            }
        } 
        return !Boolean(errors.length);
    };

    const handleCloseSnackbar = () => {
        setSnackValues({ ...snackValues, open: false });
    };

    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {
            if (error === "EMPTY NAME") {
                allErrorMessages +=
                    "," + getErrorLabel(UserErrorMessage.EmptyLastnameOrFirstname);
            } else if (error === "EMAIL USED") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.EmailUsed);
            } else if (error === "EMPTY EMAIL") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.EmptyEmail);
            } else if (error === "PASSWORD DIFFERENT") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.PasswordDifferent);
            } else if (error === "WRONG ACTUAL PASSWORD") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.WrongActualPassword);
            } else if (error === "NEW OR CONFIRM PASSWORD EMPTY") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.EmptyNewOrConfirmPassword);
            } else if (error === "SMS VALIDATION CODE WRONG") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.SmsValidationCodeWrong);
            } else if (error === "PASSWORD WEAK") {
                allErrorMessages += "," + getErrorLabel(UserErrorMessage.PasswordWeak);
            }
        });
        setErrorMessages(
            allErrorMessages.substring(1, allErrorMessages.length)
        );
    };

    const handleValidationOTP = () => {
        if (validationCodeData.smsValidationCode !== validationCodeEntered) {
            if (!errors.includes("SMS VALIDATION CODE WRONG"))
                errors = [...errors, "SMS VALIDATION CODE WRONG"];
            showErrorsMessages();
        } else {
            setLoadingValidation(true)
            profilService.confirmCodeValidation(validationCodeData.userId).then(response=>{
                if(response.success){
                    setSnackValues({
                        ...snackValues,
                        open: true,
                        message: t('common.alert.success'),
                    });
                    setLoadingValidation(false)
                    setOpenDialog(false)
                }
            }).catch(error=>{
                setLoadingValidation(true)
                profilService.confirmCodeValidation(validationCodeData.userId).then(response=>{
                    if(response.success){
                        setSnackValues({
                            ...snackValues,
                            open: true,
                            message: t('common.alert.success'),
                        });
                        setLoadingValidation(false)
                        setOpenDialog(false)
                    }
                }).catch(error=>{
                    setLoadingValidation(false)
                    //console.log('confirm code validation error', error)
                })
            })
        }
    }
    
    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (isFromValidate(allUserInfos)) {
            let data={
                ...allUserInfos
            }
            let showOTPValidationField=false;
            if((data.country=== 'Cameroon' || data.country === 'Ghana' ) && (data.phone !== oldUserInfos?.phone || data.confirmedCodeValidaton===false) && (data.phone !=='')){
                data={
                    ...allUserInfos,
                    confirmedCodeValidaton: false,
                }
                showOTPValidationField=true;
            }
            profilService
                .updateUser(data._id, data)
                .then((response) => {
                    if (response.success === true) {
                        profilService.getUserById(user._id).then((response) => {
                            if (response.success) {
                                setAllUserInfos(response.data);
                                setOldAllUserInfo(response.data);
                                if (showOTPValidationField){
                                    const codePhone=CountryPhoneList.find((item: any) => item.name===response.data.country)
                                    setOpenDialog(true);
                                    setValidationCodeData({
                                        userId: response.data._id,
                                        userEmail: response.data.email,
                                        userCountry: response.data.country,
                                        smsValidationCode: Number(response.data.registrationSmsToken),
                                        userPhone: response.data.phone,
                                        codePhone : codePhone.dial_code,
                                    })
                                }
                                setFileURL("");
                                errors = [];
                                setErrorMessages("");
                                
                                if (!showOTPValidationField){
                                    setSnackValues({
                                        ...snackValues,
                                        open: true,
                                        message: t('snackbar.messages.profil-modifie-avec-succes'),
                                    });
                                }
                            }
                        });
                    }
                    setIsUpdating(false)
                })
                .catch((error) => {
                    if (error.error === UserErrorMessageFromServer.EmailUsed) {
                        if (!errors.includes("EMAIL USED"))
                            errors = [...errors, "EMAIL USED"];
                    } else if (
                        error.error ===
                        getErrorLabel(UserErrorMessageFromServer.EmailOrPasswordNull)
                    ) {
                        if (!errors.includes("EMAIL AND PASSWORD NULL"))
                            errors = [...errors, "EMAIL AND PASSWORD NULL"];
                    } else if (error.error === UserErrorMessageFromServer.WrongActualPasswordReceived) {
                        if (!errors.includes("WRONG ACTUAL PASSWORD"))
                            errors = [...errors, "WRONG ACTUAL PASSWORD"];
                    } else if (error.error === UserErrorMessageFromServer.NewAndOrConfirmPasswordNull) {
                        if (!errors.includes("NEW OR CONFIRM PASSWORD EMPTY"))
                            errors = [...errors, "NEW OR CONFIRM PASSWORD EMPTY"];
                    }
                    showErrorsMessages();
                })
                .finally(() => {
                    setOpen(false)
                    setLoading(false);
                });
        } else {
            showErrorsMessages();
            return false;
        }
    };

    const handleClose = () => {
        setOpen(false)
        setErrorMessages('')
    }

    const handleOpen = () => {
        setOpen(true)
    }
    
    // console.log("allUserInfos",allUserInfos)
    
    return (
        <div className={classes.profil}>
            <Container>
                <form
                    className={classes.root}
                    noValidate
                    autoComplete="off"
                >
                    <Grid
                        container
                        spacing={2}
                        style={{ justifyContent: "space-around" }}
                    >
                        {
                            loadingPage && (<CircularProgress size={32} style={{ color: '#890608' }} />)
                        }
                        {
                            !loadingPage &&
                            <>
                                <Grid
                                    item
                                    lg={embed ? 12 : 3}
                                    sm={12}
                                    className={classes.avatarContainer}
                                >
                                    <div
                                        className={classes.avatar}
                                        style={{
                                            backgroundImage: `url(${fileURL
                                                ? fileURL
                                                : allUserInfos?.avatarURL
                                                })`,
                                        }}
                                    ></div>
                                    <div className={classes.changeAvatarContainer}>
                                        <input
                                            accept="image/*"
                                            className={classes.inputAvatar}
                                            id="icon-button-file"
                                            ref={inputfileRef}
                                            type="file"
                                            onChange={handlChangeAvatar}
                                        />
                                        <Button
                                            className={classes.changeAvatarButton}
                                            onClick={clickChangeAvatarInput}
                                            disabled={!isUpdating}
                                        >
                                            {t("Profil.btnChangeAvatar")}
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    lg={embed ? 12 : 8}
                                    sm={12}
                                    className={classes.personalInfoContainer}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label className={classes.label}>
                                                {t("Profil.clientId")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <label>
                                                {allUserInfos?.userID}        
                                            </label>
                                        </Grid>
                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="firstName" className={classes.label}>
                                                {t("Profil.firstname")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                id="firstName"
                                                fullWidth
                                                name="firstName"
                                                value={allUserInfos?.firstName}
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: !isUpdating }}
                                            />
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="lastName" className={classes.label}>
                                                {t("Profil.lastname")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                id="lastName"
                                                fullWidth
                                                name="lastName"
                                                value={allUserInfos?.lastName}
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: !isUpdating }}
                                            />
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="gender" className={classes.label}>
                                                {t("Profil.sex")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <Select
                                                id="gender"
                                                name="gender"
                                                fullWidth
                                                value={allUserInfos.gender}
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: !isUpdating }}
                                            >
                                                {typeGender.map(
                                                    (gender: any, i: number) => (
                                                        <MenuItem
                                                            value={gender.name}
                                                            key={gender.name + i}
                                                        >
                                                            {gender.name}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="birthDay" className={classes.label}>
                                                {t("Profil.dob")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="birthDate"
                                                name="birthDate"
                                                type="date"
                                                onChange={(d) => { handleChangeDate(d.target.name, d.target.value) }}
                                                value={moment(allUserInfos.birthDate).format('YYYY-MM-DD')}
                                                placeholder={t(
                                                    "Profil.placeholder.dob"
                                                )}
                                                inputProps={{ readOnly: !isUpdating }}
                                            />
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="phone" className={classes.label}>
                                                {t("Profil.phone")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="phone"
                                                name="phone"
                                                fullWidth
                                                onChange={onChangeHandler}
                                                value={allUserInfos.phone}
                                                type="text"
                                                placeholder={t(
                                                    "Profil.placeholder.phone"
                                                )}
                                                inputProps={{ readOnly: !isUpdating }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <>
                                                        <div style={{ marginRight: 10 }}>{codePhone}</div>
                                                        
                                                        </>
                                                    ),
                                                    endAdornment: (
                                                        <>
                                                            <InputAdornment position="end">
                                                            {
                                                            (allUserInfos.country==='Cameroun' || allUserInfos.country==='Cameroon' || allUserInfos.country==='Ghana') &&
                                                            <>                                                            
                                                                <IconButton
                                                                    aria-label="toggle new phone status"
                                                                >
                                                                    {allUserInfos.confirmedCodeValidaton ? (
                                                                        <CheckBox style={{color: colors.success}} />
                                                                    ) : (
                                                                        <Warning style={{color: colors.danger}} />

                                                                    )}
                                                                </IconButton>
                                                                
                                                                {allUserInfos.confirmedCodeValidaton ? (
                                                                        <span className={classes.label} style={{color: colors.success}}>Verified</span>
                                                                    ) : (
                                                                        <span className={classes.label} style={{color: colors.danger}}> Unverified</span>

                                                                    )}
                                                            </>
                                                            }
                                                        </InputAdornment>
                                                        </>
                                                    ),
                                                    classes: {
                                                        input: classes["input"],
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="country" className={classes.label}>
                                                {t('propriete.labels.pays')}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <Select
                                                id="country"
                                                name="country"
                                                value={allUserInfos.country}
                                                fullWidth
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: !isUpdating }}
                                            >
                                                {countriesList.map(
                                                    (value: any, i: number) => (<MenuItem key={i} value={ value.name} selected={value._id ===allUserInfos.country}>{value.name}</MenuItem>)
                                                )}
                                            </Select>
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="email" className={classes.label}>
                                                {t("Profil.email")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                id="email"
                                                fullWidth
                                                name="email"
                                                value={allUserInfos?.email}
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: !isUpdating }}
                                            />
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="actualPassword" className={classes.label}>
                                                {t("Profil.password")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="actualPassword"
                                                name="password"
                                                onChange={onChangeHandler}
                                                value={allUserInfos.password}
                                                type={
                                                    handlePassword.showPassword
                                                        ? "text"
                                                        : "password"
                                                }
                                                placeholder={t(
                                                    "Profil.placeholder.actualPassword"
                                                )}
                                                fullWidth
                                                inputProps={{ readOnly: !isUpdating }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle new password visibility"
                                                                onClick={() => handleClickShowPassword('showPassword', handlePassword.showPassword)}
                                                            >
                                                                {handlePassword.showPassword ? (
                                                                    <Visibility />
                                                                ) : (
                                                                    <VisibilityOff />
                                                                )}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    classes: {
                                                        input: classes["input"],
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        {
                                            allUserInfos._id !== '' &&
                                            <>
                                                <Grid item lg={3} sm={3} xs={12}>
                                                    <label htmlFor="newPassword" className={classes.label}>
                                                        {t("Profil.newPassword")}
                                                    </label>
                                                </Grid>
                                                <Grid item lg={9} sm={9} xs={12}>
                                                    <TextField
                                                        autoFocus
                                                        margin="dense"
                                                        id="newPassword"
                                                        name="newPassword"
                                                        onChange={onChangeHandler}
                                                        value={allUserInfos.newPassword}
                                                        type={
                                                            handlePassword.showNewPassword
                                                                ? "text"
                                                                : "password"
                                                        }
                                                        placeholder={t(
                                                            "Profil.placeholder.newPassword"
                                                        )}
                                                        fullWidth
                                                        inputProps={{ readOnly: !isUpdating }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle confirm password visibility"
                                                                        onClick={() => handleClickShowPassword('showNewPassword', handlePassword.showNewPassword)}
                                                                    >
                                                                        {handlePassword.showNewPassword ? (
                                                                            <Visibility />
                                                                        ) : (
                                                                            <VisibilityOff />
                                                                        )}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            classes: {
                                                                input: classes["input"],
                                                            },
                                                        }}
                                                    />
                                                    <div className={classes.passwordStrength} style={{ background: colorPassword }}></div>
                                                </Grid>

                                                <Grid item lg={3} sm={3} xs={12}>
                                                    <label htmlFor="confirmPassword" className={classes.label}>
                                                        {t("Profil.confirmPassword")}
                                                    </label>
                                                </Grid>
                                                <Grid item lg={9} sm={9} xs={12}>
                                                    <TextField
                                                        autoFocus
                                                        margin="dense"
                                                        id="confirmPassword"
                                                        name="confirmPassword"
                                                        onChange={onChangeHandler}
                                                        value={allUserInfos.confirmPassword}
                                                        type={
                                                            handlePassword.showConfirmPassword
                                                                ? "text"
                                                                : "password"
                                                        }
                                                        placeholder={t(
                                                            "Profil.placeholder.confirmPassword"
                                                        )}
                                                        fullWidth
                                                        inputProps={{ readOnly: !isUpdating }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle confirm password visibility"
                                                                        onClick={() => handleClickShowPassword('showConfirmPassword', handlePassword.showConfirmPassword)}
                                                                    >
                                                                        {handlePassword.showConfirmPassword ? (
                                                                            <Visibility />
                                                                        ) : (
                                                                            <VisibilityOff />
                                                                        )}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                                
                                                            ),
                                                            classes: {
                                                                input: classes["input"],
                                                            },
                                                        }}
                                                        
                                                    />                         
                                                    <div className={classes.passwordCriteria}>
                                                        <p>
                                                            {t('label.one-lowercase')}
                                                        </p>
                                                        <p>
                                                            {t('label.one-uppercase')}
                                                        </p>
                                                        <p>
                                                            {t('label.one-numeric-char')}
                                                        </p>
                                                        <p>
                                                            {t('label.one-special-char')}
                                                        </p>
                                                        <p>
                                                            {t('label.eight-char')}
                                                        </p>
                                                    </div>
                                                </Grid>  

                                            </>
                                        }
                                        
                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="relationUser" className={classes.label}>
                                            {t("register.relation")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="relationUser"
                                                name="relationUser"
                                                fullWidth
                                                onChange={onChangeHandler}
                                                value={allUserInfos.relationUser}
                                                type="text"
                                                placeholder={t('register.placeholder-relation')}
                                                inputProps={{ readOnly: !isUpdating }}
                                            />
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="NameUrgent" className={classes.label}>
                                                {t("register.nom-urgent")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="NameUrgent"
                                                name="nomUrgent"
                                                fullWidth
                                                onChange={onChangeHandler}
                                                value={allUserInfos.nomUrgent}
                                                type="text"
                                                inputProps={{ readOnly: !isUpdating }}
                                            />
                                        </Grid>

                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="phoneUrgent" className={classes.label}>
                                                {t("register.contact-urgent")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="phoneUrgent"
                                                name="phoneUrgent"
                                                fullWidth
                                                onChange={onChangeHandler}
                                                value={allUserInfos.phoneUrgent}
                                                type="text"
                                                inputProps={{ readOnly: !isUpdating }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <>
                                                        <div style={{ marginRight: 10 }}>{codePhone}</div>
                                                        
                                                        </>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                        
                                        <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="lang" className={classes.label}>
                                                {t('register.default-lang')} 
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <Select
                                                id="lang"
                                                name="lang"
                                                fullWidth
                                                value={allUserInfos.lang}
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: !isUpdating }}
                                            >
                                                {typeLang.map(
                                                    (lang: any, i: number) => (
                                                        <MenuItem
                                                            value={lang.value}
                                                            key={lang.name + i}
                                                        >
                                                            {lang.name}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </Grid>

                                        {/* <Grid item lg={3} sm={3} xs={12}>
                                            <label htmlFor="role" className={classes.label}>
                                                {t("Profil.role")}
                                            </label>
                                        </Grid>
                                        <Grid item lg={9} sm={9} xs={12}>
                                            <Select
                                                id="role"
                                                name="role"
                                                value={allUserInfos.role.name}
                                                fullWidth
                                                onChange={onChangeHandler}
                                                inputProps={{ readOnly: true }}
                                            >
                                                {typeRole.map(
                                                    (role: any, i: number) => (
                                                        <MenuItem
                                                            value={role.name}
                                                            key={role.name + i}
                                                        >
                                                            {
                                                                (allUserInfos.role.name===ERoles.SUPER_ADMIN) ? role.label : allUserInfos.accountType.toUpperCase()
                                                            }
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </Grid> */}

                                        <div
                                            className={
                                                classes.updateInfosButtonsContainer
                                            }
                                        >

                                            <Button
                                                className={classes.updateButton}
                                                onClick={
                                                    isUpdating
                                                        ? cancelUpdatingForm
                                                        : triggerUpdatingForm
                                                }
                                            >
                                                {isUpdating
                                                    ? t("Profil.buttonCancelUpdate")
                                                    : t("Profil.buttonUpdate")}
                                            </Button>

                                            {isUpdating && (
                                                <Button
                                                    size="small"
                                                    className={classes.button}
                                                    onClick={handleOpen}
                                                    disabled={loading}
                                                >
                                                    {t("Profil.buttonSave")}
                                                </Button>
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </Grid>
                </form>
                <GlobalValidationOTPDialog open={openDialog} handleClose={handleCloseLoginDialog} validationCodeEntered={validationCodeEntered} setValidationCodeEntered={setValidationCodeEntered} validationCodeData={validationCodeData} handleValidationOTP={handleValidationOTP} loadingValidation={loadingValidation} errorMessages={errorMessages}/>
                <AfriqSnackbar
                    {...snackValues}
                    handleClose={handleCloseSnackbar}
                />
                <ModalConfirm 
                    open={open} 
                    handleSubmit={handleSubmit} 
                    handleClose={handleClose} 
                    loading={loading}
                    errorMessages={errorMessages}
                />
            </Container>
        </div>
    );
}
